namespace advisorop.components.advisor {

  export class AdvisorExternalSystemWizardController {

    $router;

    //types
    externalSystems: any = domains.ExternalSystem;
    currentExternalSystem: domains.ExternalSystem;

    externalSystem: domains.IAdvisorExternalSystem;

    static $inject = ["advisorService","$scope"];
    constructor(private advisorService: services.AdvisorService, private $scope: ng.IScope) {
    }

    $routerOnActivate(next, previous) {
      if (next.params.extSystemId) {

        this.currentExternalSystem = next.params.extSystemId;

        //console.log("$_Current_system:", this.currentExternalSystem);

        this.loadExternalSystems(this.currentExternalSystem);

        if (next.params.extSystemId != 1) {
          toastr.warning("Wizard for this platform is not yet supported.");
        }
      }
    }

    $onInit(): void {

    }

    loadExternalSystems(id): void {
      this.advisorService.getExternalSystem(id)
        .then((data) => {
          this.externalSystem = data.data;
          //console.log("$_External_System:", this.externalSystem.name);
        })
        .catch((reason) => {
          console.log("Error during load externalSystems");
          console.log(reason);
        });
    }
  }


  class AdvisorExternalSystemWizard implements ng.IComponentOptions {

    public bindings: any;
    public controller: any;
    public controllerAs: string;
    public templateUrl: string;
    public $routeConfig: any;

    constructor() {
      this.bindings = {
        $router: "<",
      };
      this.controller = AdvisorExternalSystemWizardController;
      this.controllerAs = "vm";
      this.templateUrl = 'spa/advisor-module/views/advisor-external-system-wizard.html';
    }
  }
  angular.module(Constants.APP).component("advisorExternalSystemWizard", new AdvisorExternalSystemWizard());
}